import React from 'react'
import { HeaderPopupPage } from '../CreatePopup';
import useStyles from '../style'
import { Grid, Typography } from '@mui/material';
import CkeditorComp from '@components/common/ckeditor/Ckeditor';
const HeaderPopup = ()=>{
    const classes = useStyles();
    return (
        <>
            <HeaderPopupPage path='/admin/popup-management'/>
            <div className={classes.root}>
                <Grid container display='flex' alignItems='center' justifyContent='center' direction='column'>
                    <Grid item>
                        <Typography className={classes.title}>
                            Popup Headline
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography className={classes.text}>
                            Popup nằm ở vị trí trên cùng của website
                        </Typography>
                    </Grid>
                </Grid>
                <CkeditorComp 
                    title="Popup Headline" 
                    content="Popup nằm ở vị trí trên cùng của website"
                    isHeader={true}
                    popupType="Headline"
                />
            </div>
        </>
    )
}
export default HeaderPopup;
